'use strict';

wbApp.factory('urlUtils', ['$location', '$window',
    function ($location, $window) {

        function getQueryParams(qs) {
            if (!qs) {
                qs = location.search;
            }

            qs = qs.split("+").join(" ");

            var params = {}, tokens,
                re = /[?&]?([^=]+)=([^&]*)/g;

            while (tokens = re.exec(qs)) {
                params[decodeURIComponent(tokens[1])]
                    = decodeURIComponent(tokens[2]);
            }

            return params;
        }

        function getReturnUrl(params) {
            var ret = '';
            angular.forEach(params, function (value, key) {
                if (key.toLowerCase() === 'returnurl') {
                    ret = value;
                }
            });

            return ret;
        }

        function getParamsStringWithoutReturnUrl(params) {
            var ret = '';
            angular.forEach(params, function (value, key) {
                if (key.toLowerCase() !== 'returnurl') {
                    if (!!ret) {
                        ret = ret + '&' + key + '=' + value;
                    } else {
                        ret = key + '=' + value;
                    }
                }
            });

            return ret;
        }

        function getUrlParts() {
            return window.location.pathname.split('/');
        }

        function getLastUrlPart() {
            var urlParts = getUrlParts();

            if (urlParts && urlParts.length) {
                return urlParts[urlParts.length - 1];
            }

            return "";
        }

        function setUrlParam(paramName, paramValue) {
            var ret = '';

            var params = getQueryParams();
            params[paramName] = paramValue;
            _.forEach(params, function (value, key) {
                if (!!value) {
                    if (!!ret) {
                        ret = ret + '&' + encodeURIComponent(key) + '=' + encodeURIComponent(value);
                    } else {
                        ret = encodeURIComponent(key) + '=' + encodeURIComponent(value);
                    }
                }
            });

            //if (!ret && !!paramValue) {
            //    ret = encodeURIComponent(paramName) + '=' + encodeURIComponent(paramValue);
            //} else {
            //    if (!!ret && !!paramValue) {
            //        ret = ret + '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(paramValue);
            //    }
            //}

            if (!!ret) {
                $location.url($location.path() + "?" + ret);
            } else {
                $location.url($location.path());
            }
            $location.replace();
            $window.history.replaceState(null, 'any', $location.absUrl());
        }

        function removeUrlParam(paramName) {
            setUrlParam(paramName, null);
        }

        return {
            getQueryParams: getQueryParams,
            getParamsStringWithoutReturnUrl: getParamsStringWithoutReturnUrl,
            getUrlParts: getUrlParts,
            getLastUrlPart: getLastUrlPart,
            setUrlParam: setUrlParam,
            removeUrlParam: removeUrlParam,
            getReturnUrl: getReturnUrl
        }

    }]);